import {memoize} from '@servicenow/ui-internal';
import log from '../log';

/**
 * Returns parts for nested selectable properties
 * @function getPartsForNestedSelectableProps
 * @private
 *
 * @param {string} value - The value to be split
 * @returns {Array} - The parts of the value, first element is the root prop name,
 * the second element is path within the object that has the selectable prop
 */
export default memoize(
	value => {
		const dotIndex = value.indexOf('.');

		if (dotIndex === -1) {
			log(`Invalid nested selectable property name: ${value}`, {
				origin: 'get_parts_for_nested_selectable_props'
			});
			return [];
		}

		const path = value.substring(dotIndex + 1);

		if (!path) {
			log(`Invalid nested selectable property name: ${value}`, {
				origin: 'get_parts_for_nested_selectable_props'
			});
			return [];
		}

		return [value.substring(0, dotIndex), path];
	},
	{profileName: 'getPartsForNestedSelectableProps'}
);
